import { render } from "./home.vue?vue&type=template&id=d87e663e"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=d87e663e&lang=css"
script.render = render

export default script